// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__2QEhk","column":"style_column__2I3X5","row":"style_row__3c3kw"};